import { render } from "./OrderConfirmation.vue?vue&type=template&id=c6204e64&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=c6204e64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6204e64"]])

export default __exports__